<template>
  <div 
    class="header-container d-flex align-items-center" 
    @mousemove.stop
  >
    <div class="m-2 source-serif fs-5">
      {{ title }}
    </div>
    <div class="d-flex w-100 justify-content-between">
      <div class="d-flex ms-1">
        <div 
          class="first-header-tab header-tab fw-bold bg-sachlich-white p-2 lh-base" 
          :class="{ active: activeTab === 'overview'}" 
          @click="setDetailsPanelActiveTab('overview')"
        >
          Übersicht
        </div>
        <div 
          class="header-tab fw-bold bg-sachlich-white p-2 border-start-0 lh-base"
          :class="{ active: activeTab === 'cabin' }"
          @click="setDetailsPanelActiveTab('cabin')"
        >
          Tarif und Kabine
        </div>
        <div 
          class="header-tab fw-bold bg-sachlich-white p-2 border-start-0 lh-base"
          :class="{ active: activeTab === 'transportation' }"
          @click="setDetailsPanelActiveTab('transportation')"
        >
          An- und Abreise
        </div>
        <div
          class="last-header-tab header-tab fw-bold bg-sachlich-white p-2 border-start-0 lh-base"
          :class="{ active: activeTab === 'route' }"
          @click="setDetailsPanelActiveTab('route')"
        >
          Route
        </div>
        <div
          v-if="stage === 'dev'"
          class="header-tab fw-bold bg-sachlich-white p-2 lh-base rounded-pill ms-2"
          :class="{ active: activeTab === 'pdf' }"
          @click="setDetailsPanelActiveTab('pdf')"
        >
          PDF
        </div>
      </div>

      <Icon 
        type="close"
        class="me-2"
        @click="hideDetailsPanel"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useUiStore } from '@/store';
import { useAppStore } from '@/store/app';
import { mapActions, mapState } from 'pinia';
import { defineComponent } from 'vue';
import Icon from '../common/Icon.vue';

export default defineComponent({
  components: {
    Icon
  },
  props: {
    title: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    ...mapState(useAppStore, {
      stage: store => store.stage 
    }),
    ...mapState(useUiStore, {
      activeTab: store => store.detailsPanelActiveTab,
    })
  },

  methods: {
    ...mapActions(useUiStore, {
      hideDetailsPanel: 'hideDetailsPanel',
      setDetailsPanelActiveTab: 'setDetailsPanelActiveTab'
    }),
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';
@import '@gecko-akh/shared-styles/src/styles/vars.scss';

.header-container {
  height: $panel-header-height;
}

.header-tab {
  color: $color-expinet-blue;
  border: 2px solid $color-expinet-blue;
  cursor: pointer;

  &:not(.active):hover {
    border: 2px solid $color-expinet-blue-h;
    color: $color-expinet-blue-h;
  }

  &.active {
    color: $color-aida-white;
    background-color: $color-expinet-blue;
  }
}

.first-header-tab {
  border-top-left-radius: $radius-rounded;
  border-bottom-left-radius: $radius-rounded;
}

.last-header-tab {
  border-top-right-radius: $radius-rounded;
  border-bottom-right-radius: $radius-rounded;
}
</style>
